'use client';
import React, { useState } from 'react';
import MaidCards from './MaidCards';
import ApartmentCards from './ApartmentCards';
import HospitalityCards from './HospitalityCards';
import ManagerContactCard from './ManagerContactCard';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/context/LanguageContext';

export default function ServicesMain() {
  const [activeTab, setActiveTab] = useState('maids');
  const { t } = useLanguage();

  const tabs = [
    { key: 'tab-maids', id: 'maids', label: t('tabs.maids'), icon: 'UserGroupIcon', count: 24 },
    { key: 'tab-apartments', id: 'apartments', label: t('tabs.apartments'), icon: 'BuildingOffice2Icon', count: 18 },
    { key: 'tab-hospitality', id: 'hospitality', label: t('tabs.hospitality'), icon: 'SparklesIcon', count: 12 },
    { key: 'tab-manager', id: 'manager', label: t('tabs.manager'), icon: 'ChatBubbleLeftRightIcon', count: null },
  ];

  return (
    <section className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 py-10">
      {/* Tabs */}
      <div className="flex items-center gap-1 bg-white border border-border rounded-xl p-1 mb-8 overflow-x-auto scrollbar-thin">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-150 whitespace-nowrap flex-shrink-0 ${
              activeTab === tab.id
                ? 'bg-primary text-white shadow-card'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
          >
            <Icon name={tab.icon as 'UserGroupIcon'} size={16} />
            {tab.label}
            {tab.count !== null && (
              <span
                className={`text-xs px-1.5 py-0.5 rounded-full font-semibold ${
                  activeTab === tab.id ? 'bg-white/20 text-white' : 'bg-muted text-muted-foreground'
                }`}
              >
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div>
        {activeTab === 'maids' && <MaidCards />}
        {activeTab === 'apartments' && <ApartmentCards />}
        {activeTab === 'hospitality' && <HospitalityCards />}
        {activeTab === 'manager' && <ManagerContactCard />}
      </div>
    </section>
  );
}